// -- Helpers BEGIN
const windowLoad = require("%helpers%/window-load.js");
// -- Helpers END

windowLoad(function() {
	$(".about-us-tabs__top").on("click", ".about-us-tabs__top-tab:not(.about-us-tabs__top-tab_active)", function() {
		const tabId = $(this).data("tab")
		if (!tabId) return

		$(this)
			.addClass("about-us-tabs__top-tab_active")
			.siblings()
			.removeClass("about-us-tabs__top-tab_active")
			.closest(".about-us-tabs")
			.find(".about-us-tabs__content")
			.removeClass("active")

		$(`.about-us-tabs__content[data-tab="${tabId}"]`)
			.addClass("active");
	});
});
